// extracted by mini-css-extract-plugin
export default {"sidebar-header":"SidebarHeader_sidebar-header__oayIu","content":"SidebarHeader_content__GqdsM","filter-icon":"SidebarHeader_filter-icon__rnSSF"};